import axios from "axios";

export const get2dCode = ({ userId, invoiceId }) => {
  return axios.get(`/user/${userId}/invoice/${invoiceId}/2d`);
};
